//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoSwitchBasic from './demos/DemoSwitchBasic.vue'
import DemoSwitchFlat from './demos/DemoSwitchFlat.vue'
import DemoSwitchColor from './demos/DemoSwitchColor.vue'
import DemoSwitchInset from './demos/DemoSwitchInset.vue'
import DemoSwitchModelAsArray from './demos/DemoSwitchModelAsArray.vue'
import DemoSwitchStates from './demos/DemoSwitchStates.vue'
import DemoSwitchLabelSlot from './demos/DemoSwitchLabelSlot.vue'
import DemoSwitchTrueAndFalseValue from './demos/DemoSwitchTrueAndFalseValue.vue'

// code
import {
  switchBasic,
  switchFlat,
  switchColor,
  switchInset,
  switchModelAsArray,
  switchStates,
  switchLabelSlot,
  switchTrueAndFalseValue,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoSwitchBasic,
    DemoSwitchFlat,
    DemoSwitchColor,
    DemoSwitchInset,
    DemoSwitchModelAsArray,
    DemoSwitchStates,
    DemoSwitchLabelSlot,
    DemoSwitchTrueAndFalseValue,
  },
  setup() {
    return {
      codeSnippets: {
        switchBasic,
        switchFlat,
        switchColor,
        switchInset,
        switchModelAsArray,
        switchStates,
        switchLabelSlot,
        switchTrueAndFalseValue,
      },
    }
  },
}
